<!-- 门店管理 -->
<template>
  <div class="storeList">
    <!-- 顶部操作栏：搜索 + 新增，与表格拼接成整块白卡 -->
    <div class="action-bar">
      <div class="action-left">
        <div class="search-group">
          <el-input
            class="search-input"
            v-model="listQuery.store_name"
            placeholder="搜索店铺名称"
            prefix-icon="el-icon-shop"
            size="small"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
          <el-button class="btn-search" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </div>
        <el-input
          class="search-input search-input--plain"
          v-model="listQuery.store_phone"
          placeholder="店长手机号"
          size="small"
          clearable
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        ></el-input>
        <el-input
          class="search-input search-input--plain"
          v-model="listQuery.boss_name"
          placeholder="店长姓名"
          size="small"
          clearable
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        ></el-input>
        <el-button class="btn-add" type="primary" @click="handleAdd"
          >新增门店</el-button
        >
      </div>
      <div class="action-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 家门店
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="admin_id" slot-scope="{ row }">
          <el-popover trigger="hover" placement="top" v-if="!row.admin_id">
            <el-tag size="medium">{{ row.openid }}</el-tag>
            <div slot="reference" class="row-wrapper">
              <span class="store-chip is-mini">小程序端申请</span>
            </div>
          </el-popover>
          <span v-else class="store-chip">后台创建 ID:{{ row.admin_id }}</span>
        </template>
        <template slot="store_addr" slot-scope="{ row }">
          <el-tooltip
            :content="row.store_addr"
            placement="top"
            :disabled="!row.store_addr"
          >
            <span class="cell-text">{{ row.store_addr || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="store_name" slot-scope="{ row }">
          <el-tooltip
            :content="row.store_name"
            placement="top"
            :disabled="!row.store_name"
          >
            <span class="cell-text">{{ row.store_name || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="workTime" slot-scope="{ row }">
          <span :class="row.workTime ? 'cell-text' : 'cell-empty'">{{
            row.workTime || "暂未设置"
          }}</span>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" class="op-link" @click="handleEdit(row)"
              >编辑</el-button
            >
            <el-button size="mini" class="op-link" @click="handleErweima(row)"
              >二维码</el-button
            >
            <el-button size="mini" class="op-delete" @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>

      <!-- 右侧滑出抽屉：门店表单 -->
      <el-drawer
        :title="dialogName"
        :visible.sync="dialogVisible"
        direction="rtl"
        size="480px"
        :wrapper-closable="false"
        custom-class="store-drawer"
      >
        <div class="drawer-body">
          <!-- 档案头：头像 + 店铺名/手机号 -->
          <div class="drawer-profile">
            <div class="profile-avatar"><i class="el-icon-shop"></i></div>
            <div class="profile-info">
              <div class="profile-name">
                {{ dialogForm.store_name || "未命名门店" }}
              </div>
              <div class="profile-phone">
                {{ dialogForm.store_phone || "暂未填写" }}
              </div>
            </div>
          </div>

          <!-- 步骤条 -->
          <div class="step-bar">
            <div
              v-for="(step, i) in stepList"
              :key="step"
              class="step-item"
              :class="{
                done: i <= currentStep,
                current: i === currentStep,
                first: i === 0,
              }"
              >{{ step }}</div
            >
          </div>

          <!-- 跟进状态 -->
          <div class="follow-bar">
            <div class="follow-info" :class="{ 'info-inline': isAllDone }">
              <div class="follow-title">跟进状态</div>
              <div class="follow-next">
                {{ isAllDone ? "已全部完成" : "下一步：" + nextStepName }}
              </div>
            </div>
            <el-button
              v-if="!isAllDone"
              class="btn-follow"
              type="primary"
              @click="handleFollow"
              >完 成</el-button
            >
          </div>

          <!-- 礼花特效画布 -->
          <canvas ref="confetti" class="confetti-canvas"></canvas>

          <div class="feed-divider"></div>

          <!-- 门店资料 -->
          <div class="drawer-section">
            <div class="section-title">门店资料</div>

            <!-- 标签 -->
            <div class="chip-row">
              <span class="row-label">标签</span>
              <div class="chip-list">
                <span
                  v-for="t in tagOptions"
                  :key="t.text"
                  class="chip"
                  :class="[
                    'chip-' + t.type,
                    { selected: selectedTags.includes(t.text) },
                  ]"
                  @click="toggleTag(t.text)"
                >
                  {{ t.text }}
                </span>
              </div>
            </div>

            <!-- 来源 -->
            <div class="chip-row">
              <span class="row-label">来源</span>
              <div class="chip-list">
                <span
                  v-for="s in sourceOptions"
                  :key="s"
                  class="chip chip-source"
                  :class="{ selected: dialogForm.source === s }"
                  @click="dialogForm.source = s"
                >
                  {{ s }}
                </span>
              </div>
            </div>

            <el-form ref="form" :model="dialogForm" class="store-form">
              <div class="field-item field-item--primary">
                <div class="field-label">店铺名称</div>
                <el-input
                  v-model="dialogForm.store_name"
                  placeholder="暂未填写"
                  clearable
                ></el-input>
              </div>
              <div class="field-grid">
                <div class="field-item">
                  <div class="field-label">联系人</div>
                  <el-input
                    v-model="dialogForm.boss_name"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
                <div class="field-item">
                  <div class="field-label">手机号</div>
                  <el-input
                    v-model="dialogForm.store_phone"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="field-grid">
                <div class="field-item">
                  <div class="field-label">营业时间</div>
                  <el-input
                    v-model="dialogForm.workTime"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
                <div class="field-item">
                  <div class="field-label">店长 openId</div>
                  <el-input
                    v-model="dialogForm.openid"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
              </div>
              <!-- 店铺地址 -->
              <div class="field-item">
                <div class="field-label">店铺地址</div>
                <el-input
                  class="desc-input"
                  type="textarea"
                  :rows="2"
                  v-model="dialogForm.store_addr"
                  placeholder="暂未填写"
                ></el-input>
              </div>
              <div class="field-grid">
                <div class="field-item">
                  <div class="field-label">地址经度</div>
                  <el-input
                    v-model="dialogForm.longitude"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
                <div class="field-item">
                  <div class="field-label">地址纬度</div>
                  <el-input
                    v-model="dialogForm.latitude"
                    placeholder="暂未填写"
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form>

            <!-- 照片 -->
            <div class="photo-grid">
              <div class="photo-block">
                <div class="photo-label">门店照片</div>
                <div class="photo-card">
                  <div
                    class="photo-slot"
                    :class="{ filled: dialogForm.storeImg }"
                  >
                    <el-image
                      v-if="dialogForm.storeImg"
                      class="slot-img"
                      :src="dialogForm.storeImg"
                      :preview-src-list="[dialogForm.storeImg]"
                      fit="cover"
                    >
                      <div slot="error" class="thumb-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="photo-slot" v-for="n in 3" :key="n"></div>
                </div>
              </div>
              <div class="photo-block">
                <div class="photo-label">营业执照</div>
                <div class="photo-card">
                  <div
                    class="photo-slot wide"
                    :class="{ filled: dialogForm.zhizhaoImg }"
                  >
                    <el-image
                      v-if="dialogForm.zhizhaoImg"
                      class="slot-img"
                      :src="dialogForm.zhizhaoImg"
                      :preview-src-list="[dialogForm.zhizhaoImg]"
                      fit="cover"
                    >
                      <div slot="error" class="thumb-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 动态时间线 -->
          <div class="feed-divider"></div>
          <div class="feed-tabs">
            <span
              v-for="t in feedTabs"
              :key="t"
              class="feed-tab"
              :class="{ active: activeFeed === t }"
              @click="activeFeed = t"
              >{{ t }}</span
            >
          </div>
          <div class="feed-list">
            <div class="feed-item" v-for="(item, i) in currentFeedList" :key="i">
              <span class="feed-dot"></span>
              <div class="feed-main">
                <div class="feed-head">
                  <span class="feed-title">{{ item.title }}</span>
                  <span class="feed-time">{{ item.time }}</span>
                </div>
                <div class="feed-action">{{ item.action }}</div>
                <div class="feed-operator">操作人：{{ item.operator }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <el-button class="btn-cancel" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button class="btn-confirm" type="primary" @click="save"
            >确 定</el-button
          >
        </div>
      </el-drawer>

      <!-- 右侧滑出抽屉：生成二维码 -->
      <el-drawer
        title="生成二维码"
        :visible.sync="dialogCodeVisible"
        direction="rtl"
        size="480px"
        :wrapper-closable="false"
        custom-class="store-drawer"
      >
        <div class="drawer-body">
          <div class="drawer-section">
            <div class="section-title">二维码信息</div>
            <el-form ref="codeForm" :model="dialogCodeForm" class="store-form">
              <div class="field-item">
                <div class="field-label">门店</div>
                <el-input
                  v-model="dialogCodeForm.store_name"
                  placeholder="暂未填写"
                  disabled
                ></el-input>
              </div>
              <div class="field-item">
                <div class="field-label">桌号</div>
                <el-input
                  v-model="dialogCodeForm.tableNumber"
                  placeholder="如01, A01,请勿填写汉字"
                  maxlength="5"
                  clearable
                ></el-input>
              </div>
            </el-form>
            <div class="field-hint">桌号选填，用于生成门店桌码</div>
          </div>
        </div>
        <div class="drawer-footer">
          <el-button class="btn-cancel" @click="dialogCodeVisible = false"
            >取 消</el-button
          >
          <el-button class="btn-confirm" type="primary" @click="handleCreateCode"
            >确 定</el-button
          >
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import {
  addStore,
  selectStore,
  updateStore,
  deleteStore,
} from "@/services/mall/store";
import { createCode } from "@/services/mall/getCode";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  beforeDestroy() {
    if (this.confettiTimer) cancelAnimationFrame(this.confettiTimer);
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      /* 跟进步骤条 */
      stepList: ["新线索", "电话沟通", "添加微信", "产品演示", "已完成"],
      currentStep: 0,
      confettiTimer: null,
      /* 标签 / 来源 */
      tagOptions: [
        { text: "新用户", type: "red" },
        { text: "A类", type: "green" },
        { text: "B类", type: "yellow" },
        { text: "C类", type: "gray" },
      ],
      selectedTags: ["新用户"],
      sourceOptions: ["小程序搜索", "老用户介绍", "自然流量"],
      /* 动态时间线 */
      feedTabs: ["全部", "客户动态", "员工变动记录"],
      activeFeed: "全部",
      /* 客户动态 */
      feedList: [
        {
          title: "用户小程序搜索",
          action: "改为新线索",
          operator: "vv",
          time: "2025-09-10 22:33:00",
        },
        {
          title: "用户授权手机号",
          action: "改为新线索",
          operator: "vv",
          time: "2025-09-10 22:33:00",
        },
        {
          title: "客户完成首单",
          action: "升级为成交客户",
          operator: "店长张涛",
          time: "2025-08-28 15:02:11",
        },
      ],
      /* 员工变动记录 */
      employeeList: [
        {
          title: "员工入职",
          action: "李静 加入门店，岗位：店员",
          operator: "人事王敏",
          time: "2026-03-12 09:15:00",
        },
        {
          title: "岗位调整",
          action: "刘强 由店员调整为店长",
          operator: "区域经理赵磊",
          time: "2025-12-05 10:40:00",
        },
        {
          title: "门店调动",
          action: "陈晨 由旗舰店调至本门店",
          operator: "人事王敏",
          time: "2025-11-18 16:22:00",
        },
        {
          title: "员工离职",
          action: "孙宇 离职，原因：个人原因",
          operator: "人事王敏",
          time: "2025-10-09 11:05:00",
        },
      ],
      adminList: [
        { id: 0, name: "暂未开通" },
        { id: 1, name: "vip" },
        { id: 2, name: "svip" },
      ],
      /* 二维码弹窗 */
      dialogCodeVisible: false,
      dialogCodeForm: {},
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo"]),
    nextStepName() {
      return this.stepList[this.currentStep + 1] || "已全部完成";
    },
    /* 是否已全部完成 */
    isAllDone() {
      return this.currentStep >= this.stepList.length - 1;
    },
    /* 当前 Tab 对应的动态列表 */
    currentFeedList() {
      if (this.activeFeed === "客户动态") return this.feedList;
      if (this.activeFeed === "员工变动记录") return this.employeeList;
      /* 全部：合并后按时间倒序 */
      return [...this.feedList, ...this.employeeList].sort(
        (a, b) => new Date(b.time) - new Date(a.time)
      );
    },
  },
  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectStore(
        listQuery || this.listQuery
      );

      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建门店";
      this.dialogForm = {};
      this.currentStep = 0;
      this.selectedTags = [];
      this.activeFeed = "全部";
    },
    /* 生成二维码弹窗 */
    handleErweima(row) {
      this.dialogCodeVisible = true;
      this.dialogCodeForm = JSON.parse(JSON.stringify(row));
    },

    /* 确定生成二维码 */
    handleCreateCode() {
      createCode({
        store_id: this.dialogCodeForm.store_id,
        tableNumber: this.dialogCodeForm.tableNumber,
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功,前往下载!",
          });
          this.dialogCodeVisible = false;
          setTimeout(() => {
            window.open(res.data, "_blank");
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: res.data,
          });
        }
      });
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑门店";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.currentStep = 0;
      this.selectedTags = row.tag ? [row.tag] : [];
      this.activeFeed = "全部";
    },

    /* 切换标签选中 */
    toggleTag(text) {
      const i = this.selectedTags.indexOf(text);
      if (i > -1) {
        this.selectedTags.splice(i, 1);
      } else {
        this.selectedTags.push(text);
      }
    },

    /* 完成跟进，推进步骤；全部完成时放礼花 */
    handleFollow() {
      if (this.currentStep < this.stepList.length - 1) {
        this.currentStep += 1;
        if (this.currentStep === this.stepList.length - 1) {
          this.$nextTick(() => {
            this.fireConfetti();
          });
        }
      }
    },

    /* 礼花特效：两侧对角上抛的彩色纸屑 */
    fireConfetti() {
      const canvas = this.$refs.confetti;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const dpr = window.devicePixelRatio || 1;
      const width = canvas.clientWidth || 480;
      const height = canvas.clientHeight || 600;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const colors = [
        "#3D8DFC",
        "#00B42A",
        "#F53F3F",
        "#F5BE15",
        "#E6A23C",
        "#9C6BFF",
      ];
      const particles = [];
      const total = 140;
      for (let i = 0; i < total; i++) {
        const fromLeft = i % 2 === 0;
        particles.push({
          x: fromLeft ? 12 : width - 12,
          y: height - (Math.random() * 40 + 20),
          vx: fromLeft ? Math.random() * 5 + 2 : -(Math.random() * 5 + 2),
          vy: -(Math.random() * 9 + 7),
          size: Math.random() * 6 + 4,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.4,
        });
      }

      if (this.confettiTimer) cancelAnimationFrame(this.confettiTimer);
      const gravity = 0.22;
      let frames = 0;
      const draw = () => {
        ctx.clearRect(0, 0, width, height);
        let alive = 0;
        particles.forEach((p) => {
          p.vy += gravity;
          p.vx *= 0.995;
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += p.vr;
          if (p.y < height + 30) alive += 1;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
          ctx.restore();
        });
        frames += 1;
        if (alive > 0 && frames < 300) {
          this.confettiTimer = requestAnimationFrame(draw);
        } else {
          ctx.clearRect(0, 0, width, height);
          this.confettiTimer = null;
        }
      };
      draw();
    },
    /* 保存 */
    save() {
      /* 把选中的标签写回表单 */
      this.dialogForm.tag = this.selectedTags[0] || "";
      if (this.dialogName === "创建门店") {
        addStore({ ...this.dialogForm, admin_id: this.userInfo.id }).then(
          (res) => {
            if (res.code === 200) {
              this.listQuery.pageNumber = 1;
              this.getListData();
              this.$message({
                type: "success",
                message: "创建成功!",
              });
              this.dialogVisible = false;
            }
          }
        );
      }
      if (this.dialogName === "编辑门店") {
        updateStore(this.dialogForm).then((res) => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },
    /* 删除 */
    handleDelete(row) {
      this.$confirm(
        `此操作将永久删除'${row.store_name}'店铺吗, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteStore({ id: row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.storeList {
  width: 100%;
}

/* 顶部操作栏：白卡上半部，与表格拼接 */
.action-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .action-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  /* 输入框与搜索按钮拼接成一体，弱化次要操作 */
  .search-group {
    display: flex;
    align-items: center;

    /deep/ .search-input .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 6px 0 0 6px;
    }
    .btn-search {
      height: 32px;
      margin-left: -1px;
      padding: 0 16px;
      font-size: 14px;
      color: #3d8dfc;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 0 6px 6px 0;
      transition: all 0.2s;

      &:hover {
        color: #2f7be0;
        background: #f3f8ff;
        border-color: #3d8dfc;
        position: relative;
        z-index: 1;
      }
    }
  }
  .search-input {
    width: 180px;
  }
  .search-input--plain /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    border-radius: 6px;
  }
  .btn-add {
    height: 32px;
    margin-left: 12px;
    padding: 0 16px;
    font-size: 14px;
    background: #3d8dfc;
    border-color: #3d8dfc;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);
    transition: all 0.2s;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
      transform: translateY(-1px);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
      transform: translateY(0);
    }
  }

  /* 右侧统计信息，平衡一行视觉重心 */
  .action-meta {
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  /* 单元格文本：单行省略，悬浮可看全文 */
  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  .cell-empty {
    color: #c0c4cc;
  }
}

/* 来源标签：浅色底小标签 */
.store-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  background: #eaf2fe;
  color: #3d8dfc;

  &.is-mini {
    background: #e8f8ee;
    color: #00b42a;
  }
}

/* 列气泡 */
.row-wrapper:hover {
  cursor: pointer;
}

/* 图片加载失败占位 */
.thumb-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 20px;
}

/* 操作列：蓝字操作 / 删除红字 */
.operation {
  display: flex;
  align-items: center;

  .el-button {
    margin: 0;
    padding: 0 10px;
    height: 24px;
    line-height: 1;
    font-size: 13px;
    border: 1px solid transparent;
    background: transparent;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease;
  }
  .op-link {
    color: #3d8dfc;

    &:hover {
      color: #2f7be0;
    }
  }
  .op-delete {
    color: #f53f3f;
    border-left: 1px solid #e5e6eb;
    margin-left: 6px;
    padding-left: 16px;

    &:hover {
      color: #ff7875;
    }
  }
}

/* 右侧滑出抽屉 */
/deep/ .el-drawer__body {
  position: relative;
  padding: 0 0 64px;
}
/deep/ .store-drawer .el-drawer__header {
  padding: 18px 20px;
  margin-bottom: 0;
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #f0f1f3;
}
/deep/ .store-drawer .el-drawer__close-btn {
  color: #86909c;
}

.drawer-body {
  height: 100%;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 0 20px;
}

/* 档案头：圆头像 + 店铺名/手机号 */
.drawer-profile {
  display: flex;
  align-items: center;
  padding: 20px 0 24px;

  .profile-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #e5e6eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-right: 14px;
    flex-shrink: 0;
  }
  .profile-name {
    font-size: 16px;
    font-weight: 700;
    color: #1d2129;
    line-height: 22px;
  }
  .profile-phone {
    font-size: 14px;
    color: #4e5969;
    line-height: 20px;
    margin-top: 6px;
  }
}

/* 步骤条：箭头形 */
.step-bar {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
}
.step-item {
  flex: 1;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 13px;
  color: #4e5969;
  background: #f1f6fc;
  clip-path: polygon(
    0 0,
    calc(100% - 8px) 0,
    100% 50%,
    calc(100% - 8px) 100%,
    0 100%,
    8px 50%
  );
  white-space: nowrap;
  overflow: hidden;

  &.first {
    clip-path: polygon(
      0 0,
      calc(100% - 8px) 0,
      100% 50%,
      calc(100% - 8px) 100%,
      0 100%
    );
  }
  /* 已完成：填充蓝色 */
  &.done {
    background: #3d8dfc;
    color: #fff;
  }
  /* 当前所在步骤：加深蓝 + 加粗 */
  &.current {
    background: #2f7be0;
    color: #fff;
    font-weight: 600;
  }
}

/* 跟进状态 */
.follow-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .follow-title {
    font-size: 15px;
    font-weight: 700;
    color: #1d2129;
  }
  .follow-next {
    margin-top: 8px;
    font-size: 13px;
    color: #4e5969;
  }
  /* 全部完成时：标题与状态文案并排 */
  .follow-info.info-inline {
    display: flex;
    align-items: baseline;
    gap: 8px;

    .follow-next {
      margin-top: 0;
    }
  }
  .btn-follow {
    height: 34px;
    padding: 0 22px;
    font-size: 14px;
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    border-radius: 6px;
    transition: all 0.15s ease;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}

/* 礼花画布：覆盖抽屉内容区，不拦截点击 */
.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99;
}

/* 灰色分隔带 */
.feed-divider {
  height: 8px;
  background: #f2f3f5;
  margin: 20px -20px;
}

/* 分区标题 */
.drawer-section {
  margin-bottom: 4px;
}
.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #1d2129;
  margin-bottom: 18px;
}

/* 标签 / 来源 */
.chip-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.row-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  color: #4e5969;
  letter-spacing: 0.3px;
}
.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  background: #f2f3f5;
  color: #4e5969;
  border: 1px solid transparent;
  transition: all 0.15s ease;

  /* 彩色标签：浅色底 + 同色文字 */
  &.chip-red {
    background: #fdecee;
    color: #f53f3f;
  }
  &.chip-green {
    background: #e8f8ee;
    color: #00b42a;
  }
  &.chip-yellow {
    background: #fdf3e1;
    color: #e6a23c;
  }
  &.chip-gray {
    background: #f2f3f5;
    color: #a9aeb8;
  }

  /* 来源：白底描边 */
  &.chip-source {
    background: #fff;
    color: #1d2129;
    border-color: #e5e6eb;
  }
  &.chip-source.selected {
    color: #3d8dfc;
    border-color: #3d8dfc;
  }

  /* 选中态：同色描边 + 右下角对勾折角 */
  &.selected {
    border-color: currentColor;
  }
  &.selected::before {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    border-style: solid;
    border-width: 0 0 22px 22px;
    border-color: transparent transparent currentColor transparent;
    border-bottom-right-radius: 7px;
  }
  &.selected::after {
    content: "✓";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(4px, 4px);
    font-size: 14px;
    line-height: 1;
    font-weight: 700;
    color: #fff;
  }
}

/* 字段：标签弱化在上 + 灰底输入框突出内容；短字段两列并排 */
.field-item {
  margin-bottom: 14px;
}
/* 字段标题：小字号但保持足够对比，不与输入内容抢视觉 */
.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #4e5969;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}
.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.store-form /deep/ .el-input__inner {
  background: #f1f6fc;
  border: none;
  border-radius: 8px;
  height: 42px;
  line-height: 42px;
  /* 次要字段内容压浅，视觉起点留给店铺名称 */
  color: #4e5969;
  font-size: 14px;
  transition: background 0.2s ease;

  &:hover {
    background: #e8f0fb;
  }
  /* 无边框设计下，用浅蓝描边表示聚焦 */
  &:focus {
    background: #e8f0fb;
    box-shadow: 0 0 0 2px rgba(61, 141, 252, 0.18);
  }
  &::placeholder {
    color: #a9aeb8;
  }
}
.store-form /deep/ .el-input.is-disabled .el-input__inner {
  background: #e8f0fb;
  color: #86909c;
}
/* 主字段：店铺名称，仅靠略深的颜色区分，不放大不加粗，避免突兀 */
.field-item--primary /deep/ .el-input__inner {
  font-size: 14px;
  font-weight: 400;
  color: #1d2129;
}

/* 多行输入 */
.desc-input /deep/ .el-textarea__inner {
  background: #f1f6fc;
  border: none;
  border-radius: 8px;
  padding: 12px 14px;
  color: #4e5969;
  font-size: 14px;
  /* 继承页面字体，否则 textarea 会用浏览器默认的等宽字体，与单行框不一致 */
  font-family: inherit;
  line-height: 22px;
  /* 去掉右下角拖拽把手，避免高度被随意拉伸 */
  resize: none;
  transition: background 0.2s ease;

  &:hover {
    background: #e8f0fb;
  }
  &:focus {
    background: #e8f0fb;
    box-shadow: 0 0 0 2px rgba(61, 141, 252, 0.18);
  }
  &::placeholder {
    color: #a9aeb8;
  }
}

/* 照片网格 */
.photo-grid {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 16px;
  margin: 4px 0 16px;
  align-items: stretch;
}
.photo-block {
  display: flex;
  flex-direction: column;
}
.photo-label {
  font-size: 13px;
  font-weight: 500;
  color: #4e5969;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}
.photo-card {
  flex: 1;
  background: #f1f6fc;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 10px;
  min-height: 96px;
  align-items: flex-start;

  .photo-slot {
    flex: 1 1 0;
    min-width: 0;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(29, 33, 41, 0.04);
    aspect-ratio: 1 / 1;
    overflow: hidden;
    display: flex;

    &.filled {
      cursor: pointer;
    }
    .slot-img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  /* 营业执照：固定高度，不随卡片拉伸 */
  .photo-slot.wide {
    align-self: flex-start;
    aspect-ratio: auto;
    height: 72px;
    min-height: 0;
  }
}
/* 提示文字 */
.field-hint {
  font-size: 12px;
  color: #a9aeb8;
}

/* 动态时间线 */
.feed-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;

  .feed-tab {
    font-size: 14px;
    color: #4e5969;
    cursor: pointer;

    &.active {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}
.feed-list {
  .feed-item {
    position: relative;
    display: flex;
    padding-bottom: 20px;

    &::before {
      content: "";
      position: absolute;
      left: 5px;
      top: 16px;
      bottom: 0;
      width: 1px;
      background: #e5e6eb;
    }
    &:last-child::before {
      display: none;
    }

    .feed-dot {
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: #3d8dfc;
      margin: 4px 12px 0 0;
      flex-shrink: 0;
      position: relative;
      z-index: 1;
    }
    .feed-main {
      flex: 1;
    }
    .feed-head {
      display: flex;
      justify-content: space-between;

      .feed-title {
        font-size: 14px;
        font-weight: 600;
        color: #1d2129;
      }
      .feed-time {
        font-size: 12px;
        color: #86909c;
      }
    }
    .feed-action {
      margin-top: 6px;
      font-size: 13px;
      color: #1d2129;
    }
    .feed-operator {
      margin-top: 4px;
      font-size: 12px;
      color: #86909c;
    }
  }
}

/* 底部固定操作栏 */
.drawer-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 12px 20px;
  border-top: 1px solid #f0f1f3;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(29, 33, 41, 0.05);
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .btn-cancel,
  .btn-confirm {
    height: 36px;
    min-width: 104px;
    border-radius: 6px;
    font-size: 14px;
    padding: 0;
    transition: all 0.15s ease;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #dcdee3;
    color: #4e5969;

    &:hover {
      color: #1d2129;
      border-color: #c9cdd4;
      background: #f7f8fa;
    }
  }
  .btn-confirm {
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    color: #fff;
    margin-left: 12px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}
</style>
